module.exports = __webpack_public_path__ + "assets/GTAmerica-ExpandedBlack.woff2";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-ExpandedBlack.woff2
// module id = 1001
// module chunks = 19